/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaRootMiniReference,
    MediaRootMiniReferenceFromJSON,
    MediaRootMiniReferenceFromJSONTyped,
    MediaRootMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SavedSearchPartialUpdate
 */
export interface SavedSearchPartialUpdate {
    /**
     * 
     * @type {MediaRootMiniReference}
     * @memberof SavedSearchPartialUpdate
     */
    root?: MediaRootMiniReference;
    /**
     * 
     * @type {Array<string>}
     * @memberof SavedSearchPartialUpdate
     */
    query?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SavedSearchPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SavedSearchPartialUpdate
     */
    shared?: boolean;
}

export function SavedSearchPartialUpdateFromJSON(json: any): SavedSearchPartialUpdate {
    return SavedSearchPartialUpdateFromJSONTyped(json, false);
}

export function SavedSearchPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavedSearchPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'root': !exists(json, 'root') ? undefined : MediaRootMiniReferenceFromJSON(json['root']),
        'query': !exists(json, 'query') ? undefined : json['query'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
    };
}

export function SavedSearchPartialUpdateToJSON(value?: SavedSearchPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'root': MediaRootMiniReferenceToJSON(value.root),
        'query': value.query,
        'name': value.name,
        'shared': value.shared,
    };
}


